// targetのinputが空の場合/checkboxがチェックされてない場合に、buttonをdisabledにする
export default class {
  constructor() {
    const buttonSelector = '.js-form-interactive-button';
    document.querySelectorAll(buttonSelector).forEach((buttonElm) => {
      const targetElms = Array.from(document.querySelectorAll(buttonElm.dataset.target));
      const updateButtonDisabled = () => {
        const isFilledAll = targetElms.every((elm) => {
          if (elm.type === 'checkbox') {
            return elm.checked;
          }
          return !!elm.value;
        });
        buttonElm.disabled = !isFilledAll;
        buttonElm.ariaDisabled = !isFilledAll;
      };
      updateButtonDisabled();

      targetElms.forEach((targetElm) => {
        targetElm.addEventListener('input', (event) => {
          updateButtonDisabled();
        });
      });
    });
  }
}
